import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { createPortal } from "react-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
            <App />
            {
                createPortal(
                    <ToastContainer
                        className='toast-container'
                        autoClose={6000}
                        hideProgressBar
                    />,
                    document.getElementById('toasts_new')
                )
            }
            <ToastContainer
                className='toast-container'
                autoClose={6000}
                hideProgressBar
            />
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
